module.exports = __webpack_public_path__ + "static/whatsapp-ea5589b229a7dad5f4ad762704645ef1.png";